// removed by extract-text-webpack-plugin
module.exports = {"grow-business-page":"grow-business-page","page-title":"page-title","intro-card":"intro-card","lead":"lead","features-card":"features-card","features-title":"features-title","features-grid":"features-grid","feature-item":"feature-item","feature-icon":"feature-icon","feature-content":"feature-content","content-box":"content-box","alert":"alert","alert-info":"alert-info","training-video-card":"training-video-card","video-thumbnail":"video-thumbnail","play-button":"play-button","video-content":"video-content"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/static/GrowBusiness/GrowBusiness.scss
// module id = 4331
// module chunks = 1